/**
 * @date: 2023-05-18
 * @author: Kevin Hsiau <khsiau@max.md>
 * @copy: (C) Copyright 2022 MaxMD Corporation, All Rights Reserved.
 */

import React from 'react';
import Table from "@mui/material/Table";
import {TableCell, TableContainer} from "@mui/material";
import Paper from "@mui/material/Paper";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import PropTypes from "prop-types";
import {green, grey} from "@mui/material/colors";


FHIRDetailsTable.prototype = {
    details: PropTypes.object.isRequired,
}

export default function FHIRDetailsTable ({ details }) {
    return (
        <TableContainer component={Paper} sx={{ my: 2 }}>
            <Table sx={{ m: 0 }} size={'small'}>
                <TableHead>
                    <TableRow sx={{ background: green[300] }}>
                        {/* Both columns are Direct-address counts: FHIR is Endpoints with
                            connectionType direct-project, CSV is contribution.directAddressCount.
                            Capability-page Endpoints are in neither. */}
                        <TableCell>HISP Name</TableCell>
                        <TableCell>FHIR (Direct Address)</TableCell>
                        <TableCell>CSV (Direct Address)</TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {details?.map( d => (
                        <TableRow
                            key={d.name}
                            sx={{
                                '&:nth-of-type(odd)': { background: green[50] },
                                '&:nth-of-type(even)': { background: grey[50] }
                        }}>
                            <TableCell>{d.name}</TableCell>
                            <TableCell>{d.fhirCount}</TableCell>
                            <TableCell>{d.csvCount}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}